import { render, staticRenderFns } from "./ViewStudentResult.vue?vue&type=template&id=ef50c1b8&scoped=true&"
import script from "./ViewStudentResult.vue?vue&type=script&lang=js&"
export * from "./ViewStudentResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef50c1b8",
  null
  
)

export default component.exports